import { render, staticRenderFns } from "./render-card.vue?vue&type=template&id=39f86ca4"
import script from "./render-card.vue?vue&type=script&lang=js"
export * from "./render-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports